import axios, { AxiosResponse } from 'axios';
import { ApiResponse, zps_wp } from '../zps';

export type IDispenser = {
  dispenserid: number;
  eid: number;
  entid: number;
  productName: string;
  productid: string;
  quantity: number;
  status: number;
};

export interface IDispenserRequest {
  dispenserid: number;
  eid: number;
  newQuantity: number;
  productid: string;
  quantity: number;
}

export interface IDispenserResponse extends ApiResponse {
  list: IDispenser[];
  type: string;
  totalRows: number;
}

export const fetchDispensersList = (
  controller: AbortController,
  eid: number
): Promise<AxiosResponse<IDispenserResponse>> => {
  const url = `${zps_wp}/api/product/dispenser?eid=${eid}`;
  return axios.get<IDispenserResponse>(url, { signal: controller.signal });
};

export const fetchDispenserDetails = (
  controller: AbortController,
  eid: number,
  dispenserid: number
): Promise<AxiosResponse<IDispenserResponse>> => {
  const url = `${zps_wp}/api/product/dispenser?eid=${eid}&dispenserid=${dispenserid}`;
  return axios.get<IDispenserResponse>(url, { signal: controller.signal });
};

export const addDispenserDetails = (
  request: IDispenserRequest,
  controller: AbortController
): Promise<AxiosResponse<ApiResponse>> => {
  const url = `${zps_wp}/api/product/dispenser`;
  return axios.post<ApiResponse>(url, request, { signal: controller.signal });
};

export const updateDispenserDetails = (
  request: IDispenserRequest,
  controller: AbortController
): Promise<AxiosResponse<ApiResponse>> => {
  const url = `${zps_wp}/api/product/dispenser`;
  return axios.put<ApiResponse>(url, request, { signal: controller.signal });
};

export const deleteDispenser = (
  controller: AbortController,
  entid: number,
  eid: number,
  dispenserid: number
): Promise<AxiosResponse<ApiResponse>> => {
  const url = `${zps_wp}/api/product/?entid=${entid}&eid=${eid}&dispenserid=${dispenserid}`;
  return axios.delete<ApiResponse>(url, { signal: controller.signal });
};
